import { css } from "@emotion/css";
import { css as reactCss } from "@emotion/react";
import styled from "@emotion/styled";

export const spinner = css`
  animation: rotate 2s linear infinite;
  height: 100%;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const bubbleStyles = {
  wrapper: reactCss`
    --bubble-width: 8px;
    width: calc((var(--bubble-width) + 3px) * 7);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    padding: var(--spacing-4) 0;
  `,
  bubble: reactCss`
    width: var(--bubble-width);
    height: var(--bubble-width);
    animation: bubble calc(0.14s * 7) infinite ease-in-out;
    animation-delay: var(--bubble-animation-delay);
    border-radius: 50%;
    opacity: 0.5;

    @keyframes bubble {
      0% {
        transform: translateX(-100%) scale(0.4);
        opacity: 0.2;
      }

      25% {
        transform: translateX(-25%) scale(1);
        opacity: 1;
      }

      50% {
        transform: translateX(0) scale(1.2);
        opacity: 1;
      }

      75% {
        transform: translateX(25%) scale(0.6);
        opacity: 0.4;
      }

      90% {
        transform: translateX(0%) scale(0.4);
        opacity: 0;
      }

      100% {
        transform: translateX(-100%) scale(0.4);
        opacity: 0;
      }
    }
  `
};

export const path = css`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.2s ease-in-out infinite;
  stroke-linecap: round;

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }
`;

export const Wrapper = styled("div")<{ width: number }>`
  position: relative;
  width: ${props => props.width}px;
  &:before {
    content: "";
    display: block;
    padding-top: 100%;
  }
`;

export const skeletonStyles = {
  base: reactCss`
    position: relative;
    overflow: hidden;
    border-radius: var(--border-radii-base);
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: var(--border-radii-base);
      padding-top: 100%;
      background: linear-gradient(90deg, var(--skeleton-low-light) 13%, var(--skeleton-high-light) 50%, var(--skeleton-low-light) 83%);
      background-size: 200% 100%;
      animation: shimmer var(--skeleton-duration, 2s) infinite ease-in;
      animation-delay: var(--skeleton-delay, 0s);
    }
    @keyframes shimmer {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `,
  multiLineContainer: reactCss`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
  `,
  withChildren: reactCss`
    padding: 0 .2rem;
    &:after {
      opacity: 0.75;
    }
  `
};
